import { getWSUrl } from '@/utils/helpers'

const SocketPlugin = {}
SocketPlugin.install = function(Vue) {
	Vue.prototype.$socketConnect = uuid => {
		const wsUri = `${getWSUrl()}/pubsub/account/${uuid}`
		Vue.prototype.$websocket = new WebSocket(wsUri)
	}
}

export default SocketPlugin
